import React from 'react';
import { Counter } from '@/components/Counter';
import { RevealGroup, RevealItem } from '@/components/Reveal';

export const Metrics = ({ metrics = [] }) => {
  if (!metrics.length) return null;
  return (
    <section className='relative bg-[#20272A]'>
      <div className='grain absolute inset-0' />
      <div className='relative container-x py-16 lg:py-20'>
        <RevealGroup className='grid gap-8 sm:grid-cols-3'>
          {metrics.map((m) => (
            <RevealItem key={m.label}>
              <div className='border-l border-[#B88A3B]/45 pl-6'>
                <div className='font-mono-num text-4xl font-medium text-[#B88A3B] sm:text-5xl lg:text-6xl'>
                  <Counter value={m.value} suffix={m.suffix} />
                </div>
                <div className='mt-3 text-sm uppercase tracking-[0.16em] text-[#F6F5F1]/60'>{m.label}</div>
              </div>
            </RevealItem>
          ))}
        </RevealGroup>
      </div>
    </section>
  );
};
